import { CheckSquare, Square } from '@aktiia/design-system';
import { MouseEvent, useMemo } from 'react';

import { IFilterPopoverProps } from './types';

export const FilterPopover = ({ clearText, filters, getFilterText, onChange, onClear }: IFilterPopoverProps) => {
  const isAnyFilterActive = useMemo(() => {
    return Object.values(filters).some((filter) => !!filter);
  }, [filters]);

  const handleFilterClick = (type: string) => onChange({ [type]: !filters[type] });
  const handleInteralClick = (event: MouseEvent<HTMLDivElement>) => event.stopPropagation();

  return (
    <div
      className="w-[250px] bg-background-base-primary border border-border-light rounded-xl shadow-high"
      onClick={handleInteralClick}
    >
      <ul>
        {Object.keys(filters).map((key) => (
          <li
            key={key}
            className="px-4 h-[40px] flex items-center justify-between cursor-pointer"
            onClick={() => handleFilterClick(key)}
          >
            <span className="typography-title-3 text-text-primary">{getFilterText(key)}</span>
            {filters[key] ? <CheckSquare className="scale-75" /> : <Square className="scale-75" />}
          </li>
        ))}

        {isAnyFilterActive && (
          <li
            className="px-4 h-[40px] flex items-center bg-global-neuchatel-50 rounded-b-xl cursor-pointer"
            onClick={onClear}
          >
            <span className="typography-heading-6 text-text-primaryInverse">{clearText}</span>
          </li>
        )}
      </ul>
    </div>
  );
};
